import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { iAxios } from "../../lib/utils";

export const BlogStatus = () => {
    const [blogData, setBlogData] = useState([]);
    const userFilter = useSelector(st => st.tickets.userFilter);
    let total = 0;
    useEffect(() => {
        iAxios.get('/api/v1/utils/blog-status').then(res => {
            setBlogData(res.data);
        });
    }, [1]);

    // Apply the header people filter (match author by email / username / name);
    // when nothing is selected, show every author.
    const norm = (s) => (s || '').toLowerCase().trim();
    const selected = userFilter.length
        ? new Set(userFilter.flatMap(u => [norm(u.email), norm(u.username), norm(u.name)]).filter(Boolean))
        : null;
    const visibleBlogs = selected
        ? blogData.filter(b => selected.has(norm(b.email)) || selected.has(norm(b.username)) || selected.has(norm(b.name)))
        : blogData;

    const rows = visibleBlogs.map((item, idx) => {
        total += item.posts?.nodes?.length || 0;
        return (
            <tr key={item.id || item.name}>
                <td className="ds-nums">{idx + 1}</td>
                <td>
                    <a href={`https://blog.ceegees.in${item.uri}`} target="_blank" rel="noreferrer">{item.name}</a>
                </td>
                <td className="ds-nums">{item.posts?.nodes?.length}</td>
            </tr>
        );
    });

    return (
        <div className="ds-panel">
            <div className="ds-panel__head">
                <h3 className="ds-panel__title">Blog Posts</h3>
                <span className="ds-badge is-accent">{total} total</span>
            </div>
            <div className="ds-table-wrap">
                <table className="ds-table is-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Posts</th>
                        </tr>
                    </thead>
                    <tbody>{rows}</tbody>
                </table>
            </div>
        </div>
    );
};
